import script from "./tk.vue?vue&type=script&setup=true&lang=js"
export * from "./tk.vue?vue&type=script&setup=true&lang=js"

import "./tk.vue?vue&type=style&index=0&id=20ae6f51&lang=scss"

const __exports__ = script;

export default __exports__